import { h } from 'preact';
import 'jquery-file-download';
import AppAside from "../AppAside";
import store from "../../store";
import * as actions from "../../actions";
import AppAsideNav from '../AppAsideNav';

export default function MobileAppAside({ view, props, hasTemplatesPermission, uploadedImages, setUploadedImages, uploadedIcons, setUploadedIcons }) {
  function onCloseAside() {
    store.dispatch(actions.setIsMobileAside(false));
  }

  return store.getState().isMobileAside ?
    <div>
      <div className={'mob-cover'} />
      <AppAside
        withNav={store.getState().view === 'color-picker' ? false : view !== 'text-mo-edit'}
        key={'app-aside'}
        hasTemplatesPermission={hasTemplatesPermission}
        uploadedImages={uploadedImages}
        setUploadedImages={setUploadedImages}
        uploadedIcons={uploadedIcons}
        setUploadedIcons={setUploadedIcons}
      />
      <a className={'toggle-mob-aside cls'} onClick={onCloseAside}></a>
    </div> :
    <AppAsideNav
      hasTemplatesPermission={hasTemplatesPermission}
      hasPdfPermission={props.hasPdfPermission}
      isVersionPreview={props.isVersionPreview}
      view={props.view}
    />
}
